angular.module('common.services').factory('geofenceFactory', [
  '$http',
  '$filter',
  '$localStorage',
  function ($http, $filter, $localStorage) {
    var list
    this.list = []
    this.findItemById = function (id) {
      var returnValue = {
        status: 0
      }
      var item = $filter('filter')(this.list, function (e) {
        return e.id == id
      })
      if (item.length > 0) {
        returnValue.status = 1
        returnValue.item = item[0]
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }
    this.addOrUpdateItem = function (item) {
      // ~ var itemData=this.findItemById(item.id);
      // ~ if(itemData.status == 1)
      // ~ {
      // ~ this.list[itemData.index]=item;
      // ~ }
      // ~ else
      // ~ {
      this.list.push(item)
      // ~ }
    }
    this.deleteItemById = function (id) {
      var itemData = this.findItemById(id)
      if (itemData.status == 1) {
        var index = itemData.index
        this.list.splice(index, 1)
      }
    }

    /**
     * @name getGeofences
     * @desc Get all geofences for selected device
     * @param {String} deviceImei Device IMEI number
     * @returns {Promise} Array of geofences for selected device
     */
    this.getGeofences = function (deviceImei) {
      return $http({
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/geofences`
      })
    }

    /**
     * @name addGeofence
     * @desc Add new geofence
     * @param {String} deviceImei Device IMEI number
     * @param {Object} geofence Geofence to add
     * @returns {Promise} requestId
     */
    this.addGeofence = function (deviceImei, geofence) {
      const updatedGeofences = [geofence, ...this.list]
      return $http({
        method: 'PUT',
        url: `${V2_BASEURL}/devices/${deviceImei}/geofences`,
        data: updatedGeofences
      })
    }

    /**
     * @name deleteGeofence
     * @desc Delete geofence by ID
     * @param {String} deviceImei Device IMEI number
     * @param {Number} geofenceId Geofence ID
     * @returns {Promise} requestId
     */
    this.deleteGeofence = function (deviceImei, geofenceId) {
      const updatedGeofences = this.list.filter(
        fence => fence.id !== geofenceId
      )
      return $http({
        method: 'PUT',
        url: `${V2_BASEURL}/devices/${deviceImei}/geofences`,
        data: updatedGeofences
      })
    }

    return this
  }
])
